import { RegexConstants } from '@/constants/regex';
import type { languageType } from '@/stores';

const ENGLISH_MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
] as const;

const ENGLISH_DATE_PATTERN = /(\d{1,2})\s+(\d{1,2}),\s*(\d{4})/g;
const KOREAN_DATE_UNIT_PATTERN = /(\d+)\s+(년|월|일)/g;

const formatEnglishDateSegment = (month: string, day: string, year: string): string => {
    const monthNum = parseInt(month, 10);
    if (monthNum < 1 || monthNum > 12) {
        return `${month} ${day}, ${year}`;
    }
    const monthName = ENGLISH_MONTH_NAMES[monthNum - 1];
    const dayNum = parseInt(day, 10);
    return `${monthName} ${dayNum}, ${year}`;
};

const normalizeEnglishDates = (text: string): string => {
    return text.replace(ENGLISH_DATE_PATTERN, (match, month: string, day: string, year: string) => {
        const monthNum = parseInt(month, 10);
        if (monthNum < 1 || monthNum > 12) {
            return match;
        }
        return formatEnglishDateSegment(month, day, year);
    });
};

const normalizeKoreanDates = (text: string): string => {
    return text.replace(KOREAN_DATE_UNIT_PATTERN, '$1$2');
};

export const normalizeTextForTTS = (text: string, lang?: languageType): string => {
    if (!text) {
        return '';
    }
    if (lang === 'ko') {
        return normalizeKoreanDates(text);
    }
    if (lang === 'en') {
        return normalizeEnglishDates(text);
    }
    return text;
};

export const toAriaLabelText = (text?: string) => {
    if (!text) return '';

    return text.replace(RegexConstants.HTML_TAG, ' ').replace(RegexConstants.MULTIPLE_SPACES, ' ').trim();
};
